import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=d7a04d4c"
import script from "./Titlebar.vue?vue&type=script&lang=js"
export * from "./Titlebar.vue?vue&type=script&lang=js"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=d7a04d4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports